import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    deletePeerConfiguration: [],
    loading: false,
    error: null,
}

const deletePeerConfigurationSlice = createSlice({
    name: "deletePeerConfiguration",
    initialState,
    reducers: {
        fetchdeletePeerConfigurationSuccess: (state, action) => {
            state.loading = false,
                state.deletePeerConfiguration = action.payload;
        },
        fetchdeletePeerConfigurationFailure: (state, action) => {
            state.loading = false,
                state.error = action.payload;
        },
    },
})

export const {
    fetchdeletePeerConfigurationSuccess,
    fetchdeletePeerConfigurationFailure,
} = deletePeerConfigurationSlice.actions;

export default deletePeerConfigurationSlice.reducer;